import { render, staticRenderFns } from "./_base-button.vue?vue&type=template&id=dc6b9bb2&scoped=true&"
import script from "./_base-button.vue?vue&type=script&lang=js&"
export * from "./_base-button.vue?vue&type=script&lang=js&"
import style0 from "./_base-button.vue?vue&type=style&index=0&id=dc6b9bb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6b9bb2",
  null
  
)

export default component.exports